import { render, staticRenderFns } from "./SelectFontWrap.vue?vue&type=template&id=c4f0dd60&scoped=true"
import script from "./SelectFontWrap.vue?vue&type=script&lang=js"
export * from "./SelectFontWrap.vue?vue&type=script&lang=js"
import style0 from "./SelectFontWrap.vue?vue&type=style&index=0&id=c4f0dd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f0dd60",
  null
  
)

export default component.exports